import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { validateMiddleware } from '@/shared/utils/middlewares/index';
import express, { Router } from 'express';
import * as unitJobController from './unit-job.controller';
import * as unitJobValidation from './unit-job.validation';

const router: Router = express.Router({ mergeParams: true });

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(unitJobValidation.getUnitJobsByProjectId),
    unitJobController.getUnitJobsByProjectId,
  );

export default router;
